import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Ellipsis } from 'antd-mobile';
const EllipsisIndex = (props) => {
    return (_jsx(_Fragment, { children: _jsx(Ellipsis, { ...props }) }));
};
export default EllipsisIndex;
//# sourceMappingURL=index.js.map